import { cn } from '@forest/shared'
import { splitProps, type JSX } from 'solid-js'
import { m } from '~/paraglide/messages'
import closeIcon from './icons/close.svg'

// The round close button pinned to a Shop dialog panel's top-right corner:
// the product details and the starter pack offer dialog.
export function DialogCloseButton(props: {
  disabled?: boolean
  onClose: () => void
  testId?: string
}) {
  return (
    <button
      type="button"
      aria-label={m.cancel()}
      data-testid={props.testId}
      disabled={props.disabled}
      onClick={() => props.onClose()}
      class="gradient-outline absolute -right-3 -top-3 flex size-[42px] items-center justify-center rounded-full bg-white/80 backdrop-blur-xl"
    >
      <img src={closeIcon} alt="" class="size-5" />
    </button>
  )
}

// A Shop dialog's full-width green call to action (Unlock, the starter
// pack's price, View offer). Not @forest/shared's Button: that one changes
// colour while disabled or pressed, and these stay the same green while a
// purchase is pending or the dialog animates out.
export function DialogPrimaryButton(
  props: JSX.ButtonHTMLAttributes<HTMLButtonElement>,
) {
  const [local, rest] = splitProps(props, ['class'])
  return (
    <button
      type="button"
      class={cn(
        'flex h-[52px] w-full items-center justify-center gap-2 rounded-full bg-[#176361] p-4 text-base font-bold leading-5 text-white shadow-[0_0_20px_-2px_rgba(198,255,205,0.15)]',
        local.class,
      )}
      {...rest}
    />
  )
}
